import { inject, Injectable } from "@angular/core";
import { ENV_FILE_TOKEN } from "gast-common-ng2";

@Injectable({
  providedIn: "root",
})
export class UrlService {

  readonly #envConfig = inject(ENV_FILE_TOKEN);

  authServiceUrl(): string {
    return `${this.#envConfig.authServiceUrl}`;
  }

  onsetServiceUrl(): string {
    return `${this.#envConfig.onsetServiceUrl}`;
  }

  checkTanByTanValue(tanValue: number): string {
    return `${this.#envConfig.classicServiceUrl}api/public/tan/check-tan/${tanValue}`;
  }

  getBookingMappingByTanValueAndUsername(tanValue: number, username: string): string {
    return `${this.#envConfig.onsetServiceUrl}api/booking-mapping?mapping-id=${tanValue}&context=GAST_LEGACY_TAN&username=${username}`;
  }

  createBookingMapping(): string {
    return `${this.#envConfig.onsetServiceUrl}api/booking-mapping`;
  }

  createGastBookingForOnsetStudy(): string {
    return `${this.#envConfig.bookingServiceUrl}api/onset/study-booking/me`;
  }

  checkIfAlreadyEnoughParticipantForMobileVersion(): string {
    return `${this.#envConfig.onsetServiceUrl}api/booking-mapping/booking/onset-study/check-participants-mobile`;
  }

  createOnsetBookingForOnsetStudy(username: string): string {
    return `${this.#envConfig.onsetServiceUrl}api/booking-mapping/booking/onset-study?username=${username}`;
  }

  onSETPortalExamUrl(): string {
    return `${this.#envConfig.onsetPortalExamUrl}`;
  }

  sendStudyGuideTestResult(bookingId: number): string {
    return `${this.#envConfig.onsetServiceUrl}api/placement-tests/bookings/${bookingId}/send-result`;
  }
}
